import { StyleSheet } from 'react-native';
import { fontFamilyRegular, grey } from '../../../constants/palette';

export default StyleSheet.create({
  container: {
    marginBottom: 10,
    marginTop: 10,
  },
  text: {
    fontFamily: fontFamilyRegular,
    color: grey,
  },
  widgetContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    width: 300,
    height: 80,
    borderStyle: 'dashed',
    borderWidth: 1,
    borderColor: grey,
    borderRadius: 5,
    marginTop: -15,
  }
});
